var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-x-auto w-full"},[_c('vue-excel',{attrs:{"datas":_vm.excelData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }